export var DEFAULT_PAGE_VIEW_EVENT = '[Amplitude] Page View';
export var DEFAULT_SESSION_START_EVENT = 'session_start';
export var DEFAULT_SESSION_END_EVENT = 'session_end';
export var DEFAULT_FORM_START_EVENT = '[Amplitude] Form Start';
export var DEFAULT_FORM_SUBMIT_EVENT = '[Amplitude] Form Submit';
export var DEFAULT_FILE_DOWNLOAD_EVENT = '[Amplitude] File Download';
//# sourceMappingURL=constants.js.map